import type { RouteDefinition } from "../route-definition.ts";

export const adminUsageRoutes = {
  "admin.llmSpend": {
    path: "/admin/usage/llm/spend",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.llmPerformance": {
    path: "/admin/usage/llm/performance",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.llmErrors": {
    path: "/admin/usage/llm/errors",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.costsCoworlds": {
    path: "/admin/usage/costs/coworlds",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.costsKinds": {
    path: "/admin/usage/costs/cost-kinds",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.costsBreakdown": {
    path: "/admin/usage/costs/breakdown",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.centerCostSources": {
    path: "/admin/usage/costs/centers/:kind/sources",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.centerCostAttribution": {
    path: "/admin/usage/costs/centers/:kind/attribution",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.coworldCostEstimates": {
    path: "/admin/usage/costs/coworlds/:coworldId/estimates",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.coworldCostBilled": {
    path: "/admin/usage/costs/coworlds/:coworldId/billed",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.coworldCostAttribution": {
    path: "/admin/usage/costs/coworlds/:coworldId/attribution",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.llm": {
    path: "/admin/usage/llm",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.budgets": {
    path: "/admin/usage/budgets",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.costs": {
    path: "/admin/usage/costs",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.coworldCosts": {
    path: "/admin/usage/costs/coworlds/:coworldId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.roundCosts": {
    path: "/admin/usage/costs/rounds/:roundId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.centerCosts": {
    path: "/admin/usage/costs/centers/:kind",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
} as const satisfies Record<string, RouteDefinition>;
